export const TEXT_STYLE_VALUES = [
    {
        label: 'Light',
        value: 'light'
    },
    {
        label: 'Regular',
        value: 'regular'
    },
    {
        label: 'Bold',
        value: 'bold'
    }
];

export enum SECTION_BREAKS_AND_KIT_COMPONENTS_SWITCH_VALUE {
    INCLUDED = 'INCLUDE',
    EXCLUDED = 'EXCLUDE'
}
